<!-- Header -->
<div mat-dialog-title>
	{{header | translate}}
</div>

<!-- Body -->
<mat-dialog-content>

	<!-- Help String -->
	{{helpString | translate}}

	<!-- CSV Field -->
	<tyl-form-field style="width: 100%; margin-bottom: 1px;"
        [errorMessage]="csv ? 'Invalid CSV' : 'CSV is required'">
		<textarea matInput
			rows="10"
			required
            (keydown)="validateKey($event)"
            [pattern]="pattern ? pattern : '.*'"
			#csvField
			[(ngModel)]="csv"></textarea>
	</tyl-form-field>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>

	<!-- Right -->
	<div class="flex-footer-right">

		<!-- Errors -->
		<error-prompt [errorList]="errors"></error-prompt>

		<!-- Save Button -->
		<tyl-button image="Save.png"
			label="Save"
			(clickEvent)="save()"></tyl-button>

		<!-- Cancel Button -->
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>
